import { httpDeleteResponse, httpGetResponse } from '../../../../api/httpClient';
import { isJobId, isRecord, isVersion } from './generationValidation';
import { DeletionJob, DeletionRequest, VersionState } from './versionTypes';
import { invalidVersionData, isDeletionJob, isVersionState } from './versionValidation';

export const versionUrls = {
  state: (version: string): string => `/v1/delivery-map/versions/${version}`,
  deletion: (id: string): string => `/v1/delivery-map/deletions/${id}`,
};
export async function getVersionState(version: string, signal?: AbortSignal): Promise<VersionState> {
  if (!isVersion(version)) return invalidVersionData();
  const response: unknown = await httpGetResponse<unknown>(versionUrls.state(version), undefined, signal, 'no-store');
  if (!isRecord(response) || response.success !== true || !isVersionState(response.data) || response.data.version !== version) return invalidVersionData();
  return response.data;
}
export async function requestVersionDeletion(request: DeletionRequest): Promise<DeletionJob> {
  if (!isVersion(request.version) || !/^[A-Za-z0-9._:-]{1,128}$/.test(request.key)) return invalidVersionData();
  const response: unknown = await httpDeleteResponse<unknown>(versionUrls.state(request.version), { idempotencyKey: request.key });
  if (!isRecord(response) || response.success !== true || !isDeletionJob(response.data) || response.data.version !== request.version || (request.id !== undefined && response.data.id !== request.id)) return invalidVersionData();
  return response.data;
}
export async function getDeletion(id: string, version: string, signal?: AbortSignal): Promise<DeletionJob> {
  if (!isJobId(id) || !isVersion(version)) return invalidVersionData();
  const response: unknown = await httpGetResponse<unknown>(versionUrls.deletion(id), undefined, signal, 'no-store');
  if (!isRecord(response) || response.success !== true || !isDeletionJob(response.data) || response.data.id !== id || response.data.version !== version) return invalidVersionData();
  return response.data;
}
